// =====================================================================
// Generische Thumbnail-URL-Ableitung für Backend-Bilder (2026-09-01).
//
// Das Backend legt zu jeder hochgeladenen Datei Thumbnails unter
//   /api/file/thumbnails/<name>_<size>_<size>_thumbnail<ext>
// ab (Größen 100/200/400). Viele Sektionen luden bisher die Originale
// (bis zu >1 MB) in kleine Karten. Diese PURE Funktion wandelt eine
// beliebige bereits gebaute Bild-URL (absolut oder relativ) in die
// passende Thumbnail-URL um — fail-soft: alles, was kein
// /api/file/-Original ist (externe URLs, data:, bereits Thumbnails,
// Dateien ohne Endung), bleibt unverändert.
// =====================================================================

export type ApiThumbnailSize = 100 | 200 | 400;

/**
 * Leitet aus einer Bild-URL die Thumbnail-Variante ab.
 * - `null`/leer → null
 * - `data:`-URLs → unverändert
 * - bereits eine Thumbnail-URL → unverändert
 * - URLs/Pfade mit `/api/file/<datei>.<ext>` → `/api/file/thumbnails/…`
 * - alles andere (externe Bilder, ohne Endung) → unverändert
 */
export function toApiThumbnailUrl(
  url: string | null | undefined,
  size: ApiThumbnailSize,
): string | null {
  if (typeof url !== 'string') return null;
  const trimmed = url.trim();
  if (!trimmed) return null;
  if (trimmed.startsWith('data:')) return trimmed;
  if (trimmed.includes('/api/file/thumbnails/')) return trimmed;

  // "<prefix>/api/file/<dateiname>" — Dateiname ohne weitere Slashes/Query
  const match = trimmed.match(/^(.*\/api\/file\/)([^/?#]+)$/);
  if (!match) return trimmed;
  const [, prefix, fileName] = match;

  const dot = fileName.lastIndexOf('.');
  if (dot <= 0) return trimmed; // keine Endung → kein Thumbnail ableitbar
  const name = fileName.substring(0, dot);
  const ext = fileName.substring(dot);
  return `${prefix}thumbnails/${name}_${size}_${size}_thumbnail${ext}`;
}
